import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Wrench, Loader2, ArrowLeft, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Autentificare reușită");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Email sau parolă incorecte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F1E36] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 grain-overlay opacity-50" />
      <div className="relative w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="w-4 h-4" /> Înapoi la site
        </Link>
        <div
          data-testid="admin-login-card"
          className="bg-white rounded-2xl shadow-2xl p-8"
        >
          <div className="flex items-center gap-2.5 mb-6">
            <span className="w-10 h-10 rounded-lg bg-[#FF5A1F] flex items-center justify-center">
              <Wrench className="w-5 h-5 text-white" />
            </span>
            <div>
              <p className="font-display font-extrabold text-lg text-[#0F1E36] leading-none">
                SIMSERV
              </p>
              <p className="text-xs text-slate-500 mt-1">Panou de administrare</p>
            </div>
          </div>

          <h1 className="font-display text-2xl font-bold text-[#0F1E36] flex items-center gap-2">
            <Lock className="w-5 h-5 text-[#FF5A1F]" /> Autentificare
          </h1>
          <p className="text-sm text-slate-500 mt-1 mb-6">
            Accesează contul de administrator pentru a gestiona site-ul.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="font-semibold text-[#0F1E36]">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                data-testid="admin-input-username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@simserv.ro"
                className="mt-1.5"
                autoComplete="username"
              />
            </div>
            <div>
              <Label htmlFor="password" className="font-semibold text-[#0F1E36]">
                Parolă
              </Label>
              <Input
                id="password"
                type="password"
                data-testid="admin-input-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1.5"
                autoComplete="current-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-button"
              className="w-full bg-[#FF5A1F] hover:bg-[#E04B14] text-white font-semibold py-6"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Intră în cont"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
